import { useState } from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";

// Composants personnalisés de Material Dashboard 2 React
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Layouts d'authentification
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Import de votre client Axios
import api from "../../../utils/axiosConfig";

// Importez l'image de fond
import bgImage from "assets/images/bg-reset-cover.jpeg";
import IconImage from "assets/images/favicon.png";

const API_FORGOT_PASSWORD = "/api/auth/forgot-password";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setSnackbar({
        open: true,
        message: "Veuillez entrer votre adresse email.",
        severity: "warning",
      });
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await api.post(API_FORGOT_PASSWORD, { email });

      setSnackbar({
        open: true,
        message:
          response.data.message ||
          "Si cette adresse est enregistrée, vous recevrez un lien de réinitialisation.",
        severity: "success",
      });

      setEmail("");
    } catch {
      setSnackbar({
        open: true,
        message: "Une erreur est survenue. Veuillez réessayer.",
        severity: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="purple"
          borderRadius="lg"
          coloredShadow="purple"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDBox display="flex" alignItems="center" justifyContent="center" sx={{ mb: 1 }}>
            <MDBox component="img" src={IconImage} alt="Logo" width="40px" sx={{ mr: 1.5 }} />
            <MDTypography variant="h5" fontWeight="bold" color="white" sx={{ letterSpacing: 1 }}>
              {process.env.REACT_APP_BRAND_NAME}
            </MDTypography>
          </MDBox>
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={2}>
            Mot de passe oublié
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Entrez votre adresse email pour recevoir un lien de réinitialisation.
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={4}>
              <TextField
                type="email"
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </MDBox>
            <MDBox mt={6} mb={1}>
              <MDButton
                variant="gradient"
                color="purple"
                fullWidth
                type="submit"
                disabled={isSubmitting}
                endIcon={isSubmitting && <CircularProgress size={20} color="inherit" />}
              >
                Envoyer le lien
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                <Link
                  to="/authentication/sign-in"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  Retour à la connexion
                </Link>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </CoverLayout>
  );
}

export default ForgotPassword;
